import { render, staticRenderFns } from "./setReadChooseTextBySentence.vue?vue&type=template&id=2e2bdeb0&scoped=true"
import script from "./setReadChooseTextBySentence.vue?vue&type=script&lang=js"
export * from "./setReadChooseTextBySentence.vue?vue&type=script&lang=js"
import style0 from "./setReadChooseTextBySentence.vue?vue&type=style&index=0&id=2e2bdeb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2bdeb0",
  null
  
)

export default component.exports